import { render, staticRenderFns } from "./PermPlacementsFilters.vue?vue&type=template&id=05bd0218&scoped=true&"
import script from "./PermPlacementsFilters.vue?vue&type=script&lang=js&"
export * from "./PermPlacementsFilters.vue?vue&type=script&lang=js&"
import style0 from "./PermPlacementsFilters.vue?vue&type=style&index=0&id=05bd0218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bd0218",
  null
  
)

export default component.exports